module.exports = __webpack_public_path__ + "static/img/goodness4.dc8ffbd3.png";